import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full bg-background-100/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 md:py-4">
        <ol className="flex flex-wrap items-center gap-1 text-sm">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (
              <li key={index} className="flex items-center gap-1">
                {index > 0 && (
                  <i className="ri-arrow-right-s-line text-foreground-400 w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
                )}
                {isLast ? (
                  <span className="text-foreground-700 font-medium" aria-current="page">
                    {item.label}
                  </span>
                ) : item.href ? (
                  <Link
                    to={item.href}
                    className="text-foreground-500 hover:text-primary-600 transition-colors duration-200"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span className="text-foreground-500">{item.label}</span>
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
}